import React, { useState, useEffect } from 'react'
import List from './List'
import Alert from './Alert'

const getLocalStorage = () => {
  let list = localStorage.getItem('list');
  if(list){
    return JSON.parse(localStorage.getItem('list'));
  } else {
    return []
  }

}

const App = () => {

  // state used for form
  const [name,setName] = useState('');

  // state used for local storage 
  const [list, setList ] = useState(getLocalStorage);

  // state whether we are ediiting or not
  const [isEditing, setIsEditing] = useState(false);

  //edit ID - which item is edit
  const [editID,setEditID] = useState(null);

  // alert

  const [alert,setAlert] = useState({
    show:false,
    msg:'',
    type:''
    });
  

  // show alert 
  const showAlert = (show=false,type="",msg="") => {
    setAlert({show,type,msg})
  }

  // clear list 
  const clearList = () => {
    showAlert(true,'danger','List Has Been Cleared');
    setList([]);
  }
  // handle change 
  const handleChange = (e) => {
    setName(e.target.value)
  }

  // remove single item
  const removeItem = (id) => {
    showAlert(true,'danger',"Item Has Been Removed");
    setList(list.filter((item) => item.id !== id));
  }

  //edit item 
  const editItem = (id) => {
    const singleItem = list.find((item) => item.id === id);
    setIsEditing(true);
    setEditID(id);
    setName(singleItem.title);
  }

  // submit function
  const handleSubmit = (e) => {
    e.preventDefault();

    // check if name is valid 

    if(!name){
      showAlert(true,'danger','Please Add A Value')

    // show alert
    }
    else if (name && isEditing){
      setList(list.map((item) => {
        if(item.id === editID) {
          return { ...item, title: name};
        }
        return item
      })
      )
    setName('');
    setEditID(null);
    setIsEditing(false);
    showAlert(true,'success','Item Edited');
  } 
    else {
     // add item to list
     showAlert(true,'success','Item Added!');
     const newItem = {id: new Date().getTime().toString(),title:name};
     setList([...list,newItem]);
     setName('');
    }
  }
  useEffect(() => {
    localStorage.setItem('list', JSON.stringify(list));
  },[list]);

  return (
    <>
    <div className="app">
    <section className="header-center"><h3 style={{color:'white',fontSize:'30px'}}>🥕 🍉 🍪 🍷 🥗</h3></section>
      <section className="header-center"><h3 style={{color:'white',fontSize:'25px'}}>Munchies List </h3></section>
      <section className='section-center'>
      <form className="grocery-form" onSubmit={handleSubmit}>
        {alert.show && <Alert {...alert} removeAlert={showAlert} list={list}/>}
        <h3 style={{color:'grey'}}>Let's Add Some Noms : )</h3>
          <div className="form-control">
            <input 
            type="text"
            className='grocery' 
            placeholder="Munchies Please"
            value={name}
            onChange={handleChange}/>
            <button type="submit" className="submit-btn">
              {isEditing ? 'edit' : 'submit'}
            </button>
          </div>
      </form>
      {list.length > 0 && (
      <div className="grocery-container">
        <List removeItem={removeItem} items={list} editItem={editItem}/>
        <button onClick={clearList} className="clear-btn">clear items</button>
      </div>)}
    </section>
    <section style={{top:'50px'}} className="header-center"><h3 style={{color:'white',fontSize:'20px'}}>Created By <a style={{textDecoration:'italic',color:'white'}} href={"https://jashankhela.com"}>@JashanKhela 🤓</a></h3></section>
    </div>
    </>)
  
}

export default App
